<template>
  <div class="container">
    <div class="row width_full">
      <div class="col_12">
        <div class="common_title">
          <h2>{{ pageTitle }}</h2>
        </div>
        <div class="row">
          <div class="col_6">
            <div :class="['form-group', {'has_error': errorFor('title')}]">
              <label>Title (Korean)</label>
              <input type="text" class="form_global" placeholder="Title Korean" v-model="form.title">
              <template v-if="errors && errors.name">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.name" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
          </div>
          <div class="col_6">
            <div :class="['form-group', {'has_error': errorFor('title_en')}]">
              <label>Title (English)</label>
              <input type="text" class="form_global" placeholder="Title English" v-model="form.title_en">
              <template v-if="errors && errors.title_en">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.title_en" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
          </div>
          <div class="col_6">
            <div :class="['form-group', {'has_error': errorFor('image')}]">
              <label>Lecture Image</label>
              <input type="file" class="form_global" ref="imageInput" accept="image/png, image/gif, image/jpeg" @input="onFileChange($event)">
              <template v-if="errors && errors.image">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.image" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
            <div class="form-group" v-if="tempImage && tempType == 'image'">
              <div class="cross_ic p_absolute" v-if="!form.id" @click.prevent="deleteFile">
                <i class="fas fa-times"></i>
              </div>
              <img :src="tempImage" alt=""   width="150">
            </div>
          </div>
          <div class="col_6">
            <div :class="['form-group', {'has_error': errorFor('file')}]">
              <label>Lecture Video</label>
              <input type="file" class="form_global" ref="videoInput" accept="video/*" @input="onVideoFileChange($event)">
              <template v-if="errors && errors.video">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.video" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
            <div class="form-group" v-if="tempVideo">
              <div class="cross_ic p_absolute" v-if="!form.id" @click.prevent="deleteVideoFile">
                <i class="fas fa-times"></i>
              </div>
              <video width="150" :src="tempVideo" controls>
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col_12">
            <div class="form-group">
              <label>Description</label>
              <text-editor v-model:text="form['description']" :id="'description'" :height="500"></text-editor>
            </div>
          </div>
        </div>
        <div class="d_flex_end">
          <button class="btn btn_danger mr_10" @click="cancelForm()">Cancel</button>

          <button class="btn btn_common" @click="submitForm()">Save</button>
        </div>
        <br>
        <br>
        <br>
      </div>

    </div>
  </div>
</template>

<script>
import TextEditor from "../../components/shared/TextEditor";
export default {
  name: "Form",
  components: {TextEditor},
  data(){
    return {
      pages: [],
      form:{
        title: '',
        title_en: '',
        image: '',
        file: '',
        description: '',
      },
      tempImage: '',
      tempType: '',
      tempVideo: '',
      pageTitle: 'Add New Lecture'
    }
  },
  created() {
    if(this.$route.name === 'lecture_edit') {
      this.pageTitle = "Edit Lecture"
      this.loadCurrentPage()
    }
  },
  methods:{
    onFileChange(event){
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length)
        return;

      let file = event.target.files[0]
      this.form.image = file

      let imageTypes = ['image/png', 'image/gif', 'image/jpeg']
      let videoTypes = ['video/mp4','video/x-m4v']

      if(imageTypes.includes(file.type)){
        this.tempType = 'image'
      }else if(videoTypes.includes(file.type)){
        this.tempType = 'video'
      }
      this.tempImage = URL.createObjectURL(file);
    },
    onVideoFileChange(event){
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length)
        return;

      let file = event.target.files[0]
      this.form.file = file

      this.tempVideo = URL.createObjectURL(file);
    },
    deleteFile(){
      this.tempImage = null
      this.tempType = null
      this.form.image = null
      this.$refs.imageInput.value = null
    },
    deleteVideoFile(){
      this.tempVideo = null
      this.form.file = null
      this.$refs.videoInput.value = null
    },

    loadCurrentPage(){
      this.axios.get('/lectures/'+this.$route.params.id)
          .then((response) => {
            this.form = response.data.data
            this.tempType = this.form.file_type
            this.tempImage = this.form.image
            this.tempVideo = this.form.file
          })
    },
    submitForm(){
      this.errors = null;
      this.loading = true;

      let formData = new FormData()

      Object.keys(this.form).forEach(key => {
        formData.append(key, this.form[key] ? this.form[key] : '');
      })

      if(this.$route.name === 'lecture_edit') {
        formData.append('_method','PATCH')
        this.axios.post('/lectures/'+this.$route.params.id, formData)
            .then(() => {
              this.$router.push({name: 'lecture'})
              this.showSuccessMsg('Lecture Updated!')
            })
            .catch((err) => {
              this.errors = err.response.data.errors
            })
            .finally(() => {
              this.loading = false;
            })
      } else {
        this.axios.post('/lectures', formData)
            .then(() => {
              this.$router.push({name: 'lecture'})
              this.showSuccessMsg('Lecture Added!')
            })
            .catch((err) => {
              this.errors = err.response.data.errors
            })
            .finally(() => {
              this.loading = false;
            })
      }
    },
    cancelForm(){
      this.$router.push({name: 'lecture'})
    }
  }
}
</script>